"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8268],{

/***/ 56749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61310);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Shared_TimeAgoCustom_TimeAgoArabicFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4526);
/* harmony import */ var _services_Requests__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19061);
/* harmony import */ var _Shared_CategoriesLinks_CategoriesLinks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77382);
/* harmony import */ var _HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17080);
/* harmony import */ var apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42155);
/* harmony import */ var _Thumbnail__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13009);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50501);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81192);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63201);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36968);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_15__);








// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper';








var HorizontalFooter2VideoNewsSlider = function(param) {
    var videoNewsList = param.videoNewsList;
    var navigationPrevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationNextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "newsSliderText newsSlider2Text video_newsSlider_wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "TileBar scrollbarHeader heading_border",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "float-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            styles: "yellowTitle",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: "أحدث مقاطع الفيديو"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sliderArrows text-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "slider-arrow arrow-prev",
                                                ref: navigationPrevRef,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "slider-arrow arrow-next",
                                                ref: navigationNextRef,
                                                children: "Next"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "clearfix"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                    navigation: {
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current
                    },
                    dir: "rtl",
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    breakpoints: {
                        "1024": {
                            slidesPerView: 4
                        },
                        "992": {
                            slidesPerView: 4
                        },
                        "575": {
                            slidesPerView: 3
                        },
                        "375": {
                            slidesPerView: 1.5
                        },
                        "320": {
                            slidesPerView: 1.5
                        }
                    },
                    pagination: false,
                    modules: [
                        apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_8__/* .Navigation */ .W_,
                        apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl
                    ],
                    className: "mySwiper",
                    children: (videoNewsList === null || videoNewsList === void 0 ? void 0 : videoNewsList.length) > 0 && videoNewsList.map(function(video, index) {
                        var ref, ref1, ref2, ref3;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "slider-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "NewsBox ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/".concat(video === null || video === void 0 ? void 0 : video.routePath),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "#",
                                                "aria-label": "Go to 141",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "newsImage",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            showThumbnail: true,
                                                            className: "img-fluid",
                                                            src: (video === null || video === void 0 ? void 0 : (ref = video.thumbnail) === null || ref === void 0 ? void 0 : ref.url) ? video === null || video === void 0 ? void 0 : (ref1 = video.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url : (video === null || video === void 0 ? void 0 : (ref2 = video.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.path) ? _services_Requests__WEBPACK_IMPORTED_MODULE_5__/* .fileUrl */ ._h + (video === null || video === void 0 ? void 0 : (ref3 = video.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.path) : _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "PlayTime",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                                                    data: video === null || video === void 0 ? void 0 : video.video
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "PlayButton-featured_50 PlayButton-base ",
                                                                    "data-type": "play",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "PlayButton-flyout",
                                                                            children: "شاهد الآن"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "icon-play-triangle PlayButton-icon",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                className: "fa play_medium"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "newscontent",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        href: "/".concat(video === null || video === void 0 ? void 0 : video.routePath),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                            href: "#",
                                                            "aria-label": "Go to 142",
                                                            children: [
                                                                video && (video === null || video === void 0 ? void 0 : video.title),
                                                                " "
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_CategoriesLinks_CategoriesLinks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            categories: video && (video === null || video === void 0 ? void 0 : video.categories)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_TimeAgoCustom_TimeAgoArabicFormat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                date: video === null || video === void 0 ? void 0 : video.createdAt
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index)
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalFooter2VideoNewsSlider);


/***/ }),

/***/ 43770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _frontend_styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61310);
/* harmony import */ var _services_GetData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17004);
/* harmony import */ var _services_Requests__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19061);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Shared_CategoriesLinks_CategoriesLinks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77382);
/* harmony import */ var _HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17080);
/* harmony import */ var _Shared_TimeAgoCustom_TimeAgoArabicFormat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4526);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50501);
/* harmony import */ var _Thumbnail__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13009);
/* harmony import */ var apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42155);
/* harmony import */ var apps_frontend_services_Util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80368);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81192);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63201);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36968);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_16__);











// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper';







var MostWatchedSlider = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), mostWatchedNewsList = ref[0], setMostWatchedNewsList = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_services_GetData__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("".concat(_services_Requests__WEBPACK_IMPORTED_MODULE_4__/* .requests.mostWatchedNews */ .E7.mostWatchedNews, "&limit=10&offset=0"), {}, "get", false).then(function(res) {
            var ref, ref1;
            var mostWatchedNews = ((ref = res.data) === null || ref === void 0 ? void 0 : ref.response) ? (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.response : {};
            setMostWatchedNewsList(mostWatchedNews);
        }).catch(function(err) {
            console.warn(err);
        });
    }, []);
    var navigationPrevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationNextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "newsSliderText newsSlider2Text video_newsSlider_wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: " heading_border mt-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-sm-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "float-end",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        styles: "yellowTitle",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: "الأكثر مشاهدة"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-sm-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sliderArrows text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "slider-arrow arrow-prev",
                                            ref: navigationPrevRef,
                                            children: "Previous"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "slider-arrow arrow-next",
                                            ref: navigationNextRef,
                                            children: "Next"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_11__/* .Swiper */ .tq, {
                    navigation: {
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current
                    },
                    dir: "rtl",
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    breakpoints: {
                        "1024": {
                            slidesPerView: 4
                        },
                        "992": {
                            slidesPerView: 4
                        },
                        "575": {
                            slidesPerView: 3
                        },
                        "375": {
                            slidesPerView: 1.5
                        },
                        "320": {
                            slidesPerView: 1.5
                        }
                    },
                    pagination: false,
                    modules: [
                        apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_11__/* .Navigation */ .W_,
                        apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_11__/* .Pagination */ .tl
                    ],
                    className: "mySwiper",
                    children: Object.values(mostWatchedNewsList).map(function(newsItem, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                        newsItem["routePath"] = (0,apps_frontend_services_Util__WEBPACK_IMPORTED_MODULE_17__/* .buildNewsRoute */ .uC)(newsItem === null || newsItem === void 0 ? void 0 : newsItem.id, newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt, newsItem === null || newsItem === void 0 ? void 0 : (ref = newsItem.seoDetail) === null || ref === void 0 ? void 0 : ref.slugLine, newsItem === null || newsItem === void 0 ? void 0 : newsItem.title);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_11__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "slider-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "NewsBox ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "newsImage",
                                            children: (newsItem === null || newsItem === void 0 ? void 0 : newsItem.contentType) === "VIDEO" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                    href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "#",
                                                        "aria-label": "Go to 143",
                                                        children: [
                                                            (newsItem === null || newsItem === void 0 ? void 0 : (ref1 = newsItem.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                showThumbnail: true,
                                                                className: "img-fluid",
                                                                src: newsItem === null || newsItem === void 0 ? void 0 : (ref2 = newsItem.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url
                                                            }) : (newsItem === null || newsItem === void 0 ? void 0 : (ref3 = newsItem.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.path) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                showThumbnail: true,
                                                                className: "img-fluid",
                                                                src: _services_Requests__WEBPACK_IMPORTED_MODULE_4__/* .fileUrl */ ._h + (newsItem === null || newsItem === void 0 ? void 0 : (ref4 = newsItem.thumbnail) === null || ref4 === void 0 ? void 0 : ref4.path)
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                showThumbnail: true,
                                                                className: "img-fluid",
                                                                src: _frontend_styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "PlayTime",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                                                        data: newsItem === null || newsItem === void 0 ? void 0 : newsItem.video
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "PlayButton-featured_50 PlayButton-base ",
                                                                        "data-type": "play",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "PlayButton-flyout",
                                                                                children: "شاهد الآن"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "icon-play-triangle PlayButton-icon",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                    className: "fa play_medium"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : (newsItem === null || newsItem === void 0 ? void 0 : (ref5 = newsItem.image) === null || ref5 === void 0 ? void 0 : ref5.url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                showThumbnail: true,
                                                className: "img-fluid",
                                                src: newsItem === null || newsItem === void 0 ? void 0 : (ref6 = newsItem.image) === null || ref6 === void 0 ? void 0 : ref6.url
                                            }) : (newsItem === null || newsItem === void 0 ? void 0 : (ref7 = newsItem.image) === null || ref7 === void 0 ? void 0 : ref7.path) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                showThumbnail: true,
                                                className: "img-fluid",
                                                src: _services_Requests__WEBPACK_IMPORTED_MODULE_4__/* .fileUrl */ ._h + (newsItem === null || newsItem === void 0 ? void 0 : (ref8 = newsItem.image) === null || ref8 === void 0 ? void 0 : ref8.path)
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                showThumbnail: true,
                                                className: "img-fluid",
                                                src: _frontend_styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "newscontent",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                        href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            "aria-label": "Go to 144",
                                                            children: newsItem === null || newsItem === void 0 ? void 0 : newsItem.title
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_CategoriesLinks_CategoriesLinks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            categories: newsItem && (newsItem === null || newsItem === void 0 ? void 0 : newsItem.categories)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_TimeAgoCustom_TimeAgoArabicFormat__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                date: newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index)
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MostWatchedSlider);


/***/ })

}]);